import { createSlice } from '@reduxjs/toolkit';
import { RemindersListStateType } from 'src/types/remindersList';

const initialState: RemindersListStateType = {
    data: null,
    loading: false,
    error: false,
    params: {},
};
export const remindersListSlice = createSlice({
    name: 'remindersList',
    initialState,
    reducers: {
        getRemindersListFetch: (state, action) => {
            state.loading = true;
            state.error = false;
            state.params = action.payload;
        },
        getRemindersListFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getRemindersListFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const {
    getRemindersListFetch,
    getRemindersListFetchSuccess,
    getRemindersListFetchFailure,
} = remindersListSlice.actions;

export default remindersListSlice.reducer;
